import commonState from '@/store/modules/common/state';
import dayjs from 'dayjs';

export default {
	SET_FORWARD_LINES(state, payload) {
		state.forwardLines = payload;
	},

	SET_BACKWARD_LINES(state, payload) {
		state.backwardLines = payload;
	},

	CLEAR_LINES(state) {
		state.forwardLines = [];
		state.backwardLines = [];
	},

	SET_BOOK_LIST(state, payload) {
		const serviceTypeCode = commonState.serviceInfo?.serviceTypeCode;
		if (serviceTypeCode === 'PGT-FESTA') {
			// 페스타
			state.bookList = payload;
			return;
		}
		// 명절버스
		state.bookList = payload.map(bookInfo => {
			bookInfo.lines = bookInfo.lines.map(lineInfo => {
				lineInfo.uid = lineInfo.bookDetails[0].bookUid; // bookUid
				lineInfo.bookDate = lineInfo.bookDetails[0].expectedOnDtm; // 예약날짜
				lineInfo.expectedOnStationName =
					lineInfo.bookDetails[0].expectedOnStationName; // 승차정류장 이름
				lineInfo.expectedOffStationName =
					lineInfo.bookDetails[0].expectedOffStationName; // 하차정류장 이름
				lineInfo.expectedOnStationUid =
					lineInfo.bookDetails[0].expectedOnStationUid; // 승차정류장 uid
				lineInfo.expectedOffStationUid =
					lineInfo.bookDetails[0].expectedOffStationUid; // 하차정류장 uid
				lineInfo.departureTimeText = dayjs(
					lineInfo.bookDetails[0].expectedOnDtm,
				).format('HH:mm'); // 승차정류장 출발시간
				lineInfo.bookCount = lineInfo.bookDetails.length; // 탑승자 수
				lineInfo.bookAmount = lineInfo.bookDetails.reduce(
					(totalAmount, bookInfo) => totalAmount + bookInfo.bookAmount,
					0,
				); // 요금
				lineInfo.seatInfos = lineInfo.bookDetails.reduce(
					(seatInfos, bookInfo) => {
						if (!bookInfo.seatNo) {
							return seatInfos;
						}
						seatInfos[bookInfo.busOrder] = seatInfos[bookInfo.busOrder]
							? [...seatInfos[bookInfo.busOrder], bookInfo.seatNo].sort(
									(a, b) => {
										return a > b ? 1 : -1;
									},
							  )
							: [bookInfo.seatNo];
						return seatInfos;
					},
					[],
				); // 좌석
				return lineInfo;
			});
			return bookInfo;
		});
	},

	SET_BOOK_STEPS(state, payload) {
		state.bookSteps = [];
		const serviceInfo = commonState.serviceInfo;
		const serviceTypeCode = serviceInfo?.serviceTypeCode;
		const insurance = serviceInfo?.contentProps?.pages?.insurance;

		const joinFirst =
			commonState.serviceInfo?.contentProps?.pages?.joins?.[0].joinFirst ||
			false;
		const canBookRoundTripYn = payload.bookableDates.length
			? payload.bookableDates[0].canBookRoundTripYn
			: false;
		const canBookForwardYn = payload.bookableDates.length
			? payload.bookableDates[0].canBookForwardYn
			: false;
		const canBookBackwardYn = payload.bookableDates.length
			? payload.bookableDates[0].canBookBackwardYn
			: false;

		const forwardPage = {
			page: 'Forward',
			pageName:
				serviceTypeCode === 'PGT-HOLIDA'
					? '귀향행 예약하기'
					: '행사장행 예약하기',
		};
		const backwardPage = {
			page: 'Backward',
			pageName:
				serviceTypeCode === 'PGT-HOLIDA'
					? '귀경행 예약하기'
					: '귀가행 예약하기',
		};
		const clausePage = {
			page: 'Clause',
			pageName:
				serviceTypeCode === 'PGT-HOLIDA' ? '여행자 보험 신청' : '면책사항 동의',
		};
		const certificationPage = {
			page: 'Certification',
			pageName:
				serviceTypeCode === 'PGT-HOLIDA' ? '기본 정보 입력' : '인증하기',
		};
		const payPage = {
			page: 'Pay',
			pageName: '결제하기', // Pay.vue에서 무료 예약인 경우 "예약하시겠습니까?" 문구를 화면에 표출
		};

		if (!canBookRoundTripYn && !canBookForwardYn && !canBookBackwardYn) {
			return;
		}

		if (canBookRoundTripYn) {
			state.bookSteps.push(forwardPage);
			state.bookSteps.push(backwardPage);
		} else {
			if (canBookForwardYn) {
				state.bookSteps.push(forwardPage);
			}
			if (canBookBackwardYn) {
				state.bookSteps.push(backwardPage);
			}
		}

		// 명절버스가 아니거나, 명절버스인 경우 여행자보험 정보가 있는 경우에만 clause 화면을 표출한다.
		if (
			serviceTypeCode !== 'PGT-HOLIDA' ||
			(serviceTypeCode === 'PGT-HOLIDA' && insurance)
		) {
			state.bookSteps.push(clausePage);
		}

		if (joinFirst) {
			state.bookSteps.unshift(certificationPage);
		} else {
			state.bookSteps.push(certificationPage);
		}

		state.bookSteps.push(payPage);
	},

	SET_ETCBOOK_STEPS(state, payload) {
		state.etcBookSteps = [];

		const serviceInfo = commonState.serviceInfo;
		const serviceTypeCode = serviceInfo?.serviceTypeCode;
		const insurance = serviceInfo?.contentProps?.pages?.insurance;

		const joinFirst =
			commonState.serviceInfo?.contentProps?.pages?.joins?.[0]?.joinFirst ||
			false;
		const canBookForwardYn = payload?.bookableDates?.length
			? payload.bookableDates[0].canBookForwardYn
			: false;
		const canBookBackwardYn = payload?.bookableDates?.length
			? payload.bookableDates[0].canBookBackwardYn
			: false;

		const forwardPage = {
			page: 'EtcForward',
			pageName: '귀향버스 신청하기',
		};
		const backwardPage = {
			page: 'EtcBackward',
			pageName: '귀경행 신청하기',
		};
		const clausePage = {
			page: 'EtcClause',
			pageName: '여행자 보험 신청',
		};
		const certificationPage = {
			page: 'EtcCertification',
			pageName: '기본 정보 입력',
		};
		const payPage = {
			page: 'EtcPay',
			pageName: '신청내역 확인하기',
		};

		if (!canBookForwardYn && !canBookBackwardYn) {
			return;
		}
		if (canBookForwardYn) {
			state.etcBookSteps.push(forwardPage);
		}
		if (canBookBackwardYn) {
			state.etcBookSteps.push(backwardPage);
		}

		// 명절버스가 아니거나, 명절버스인 경우 여행자보험 정보가 있는 경우에만 clause 화면을 표출한다.
		if (
			serviceTypeCode !== 'PGT-HOLIDA' ||
			(serviceTypeCode === 'PGT-HOLIDA' && insurance)
		) {
			state.etcBookSteps.push(clausePage);
		}

		if (joinFirst) {
			state.etcBookSteps.unshift(certificationPage);
		} else {
			state.etcBookSteps.push(certificationPage);
		}
		state.etcBookSteps.push(payPage);
	},

	REMOVE_BOOK_STEP(state, payload) {
		state.bookSteps = state.bookSteps.filter(
			bookStep => bookStep.page !== payload,
		);
	},

	REMOVE_ETC_BOOK_STEP(state, payload) {
		state.etcBookSteps = state.etcBookSteps.filter(
			bookStep => bookStep.page !== payload,
		);
	},

	SET_WITH_CALENDAR_YN(state, payload) {
		state.withCalendarYn = payload.length >= 10;
	},

	SET_BOOK_UID(state, payload) {
		state.bookUid = payload.uid;
	},

	SET_PG_LIST(state, payload) {
		state.pgList =
			payload?.map(pg => {
				switch (pg.code) {
					case 'PGC-FREE':
						pg.displayText = '무료';
						break;
					case 'PGC-KCP':
						pg.displayText = '신용카드';
						break;
					case 'PGC-KAKAOP':
						pg.displayText = '카카오페이';
						break;
				}
				return pg;
			}) ?? [];
	},

	SET_IS_FORWARD_BOOK_COUNT_EXCEEDED(state, payload) {
		state.isForwardBookCountExceeded = payload;
	},

	SET_IS_BACKWARD_BOOK_COUNT_EXCEEDED(state, payload) {
		state.isBackwardBookCountExceeded = payload;
	},

	SET_BOOKABLE_DATES(state, payload) {
		state.bookableDates = payload;
	},

	SET_ETC_BOOKABLE_DATES(state, payload) {
		state.etcBookableDates = payload;
	},
};
